// extracted by mini-css-extract-plugin
module.exports = {"myTempUploadVueDropzone":"index_myTempUploadVueDropzone_2C8RM"};